import React from 'react';
import ReactDOM from 'react-dom/client';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const stripePromise = loadStripe("pk_live_51MkDNUKx0rXRL6v7CPCCeukNvoyvRBJJC8igLsmC1wR3BN4qx9BrAZ6VnZiy7Hqg0E3m4jg0esk8qFejT5HMRN3h00CCt4iMlG");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <Elements stripe={stripePromise}>
    <App />
  </Elements>,
  </React.StrictMode>
);
reportWebVitals();
